/* unplugin-vue-components disabled */import script from "./jgsz.vue?vue&type=script&lang=ts&setup=true"
export * from "./jgsz.vue?vue&type=script&lang=ts&setup=true"

import "./jgsz.vue?vue&type=style&index=0&id=36f17d84&lang=less&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-36f17d84"]])

export default __exports__